import React from "react";
import { useTable, useSortBy, usePagination } from "react-table";

import "./Table.scss";

const SortableTable = ({
  columns,
  data,
  NoDataComponent,
  className,
  gotoPage,
  previousPage,
  nextPage,
  canPreviousPage,
  canNextPage,
  pageIndex,
  setPageSize,
  pageSize,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageSize: 1,
      },
    },
    useSortBy,
    usePagination
  );

  if (data.length === 0)
    return (
      <>
        <table
          {...getTableProps()}
          className={
            className || "table-auto w-full bg-white mt-4 mx-auto shadow-md"
          }
        >
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  // Add the sorting props to control sorting. For this example
                  // we can add them into the header props
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className="border px-4 py-3 text-gray-800 bg-gray-200 text-left uppercase text-sm"
                  >
                    {column.render("Header")}
                    {/* Add a sort direction indicator */}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? " 🔽"
                          : " 🔼"
                        : ""}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
        </table>
        <NoDataComponent></NoDataComponent>
        <PaginationComponent
          gotoPage={gotoPage}
          nextPage={nextPage}
          pageIndex={pageIndex}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
          setPageSize={setPageSize}
          pageSize={pageSize}
        ></PaginationComponent>
      </>
    );

  return (
    <>
      <table
        {...getTableProps()}
        className={
          className || "table-auto w-full bg-white mt-4 mx-auto shadow-md"
        }
      >
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                // Add the sorting props to control sorting. For this example
                // we can add them into the header props
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  className="border px-4 py-3 text-gray-800 bg-gray-200 text-left uppercase text-sm"
                >
                  {column.render("Header")}
                  {/* Add a sort direction indicator */}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? " 🔽"
                        : " 🔼"
                      : ""}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td
                      {...cell.getCellProps()}
                      className={`border px-4 py-3 text-gray-700 ${
                        i % 2 !== 0 ? "bg-gray-100" : ""
                      }`}
                    >
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      <PaginationComponent
        gotoPage={gotoPage}
        nextPage={nextPage}
        pageIndex={pageIndex}
        previousPage={previousPage}
        canPreviousPage={canPreviousPage}
        canNextPage={canNextPage}
        setPageSize={setPageSize}
        pageSize={pageSize}
      ></PaginationComponent>
    </>
  );
};

const PaginationComponent = ({
  gotoPage,
  previousPage,
  pageIndex,
  nextPage,
  canPreviousPage,
  canNextPage,
  pageSize,
  setPageSize,
}) => {
  return (
    <div className="bg-gray-200 flex p-1 border mt-2 justify-between items-center">
      <div className="flex justify-start items-center">
        <button
          onClick={() => gotoPage(0)}
          disabled={!canPreviousPage}
          className="border py-2 px-4 rounded bg-white"
        >
          {"Inicio"}
        </button>
        {/* <select
          className="ml-4 block appearance-none bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
          }}
        >
          {[10, 20, 30, 40, 50].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Mostrar {pageSize} órdenes
            </option>
          ))}
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </select> */}
      </div>
      <div className="flex items-center justify-between">
        <button
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
          className="border py-2 px-4 rounded bg-white"
        >
          {"Anterior"}
        </button>{" "}
        <span className="mx-4">
          Página <strong>{pageIndex + 1}</strong>{" "}
        </span>
        <button
          onClick={() => nextPage()}
          disabled={!canNextPage}
          className="border py-2 px-4 rounded bg-white"
        >
          {"Siguiente"}
        </button>
      </div>{" "}
    </div>
  );
};
export default SortableTable;
